import { ApiProperty } from '@nestjs/swagger';

export class CapabilitiesDto<
  T extends Record<string, boolean> = Record<string, boolean>,
> {
  @ApiProperty({ type: Object, additionalProperties: { type: 'boolean' } })
  capabilities!: T;
}
